import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {

  authUrl = 'http://172.31.3.10:8080/rc/rest/agent/login';

  constructor(public http: HttpClient) {
    console.log('Hello AuthProvider Provider');
  }

  getAuth(){
      let headers = new HttpHeaders();
     headers =  headers.set('Cache-Control','no-cache')
     .set('Postman-Token','e069e374-7abc-453a-ad39-ed234a1262e4')
      .set('userName','100006')
      .set('password','password');

      this.http.post(this.authUrl,{},{headers})
      .subscribe(response => console.log(response))
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts